import ModalBase from './modal';
import { ReactComponent as ErrorIcon } from '../../assets/images/icons/error.svg';

export default function ModalError(props) {
  return <ModalBase {...props} icon={<ErrorIcon />} />;
}
